module.exports = __webpack_public_path__ + "static/media/blog-christmas-featured-s@2x.47d7200e.jpg";